export default __webpack_public_path__ + "static/media/undraw_tabs_re_a2bd.993f000f.svg";